import * as React from 'react';
import AreaNav from '../../components/areaNav';

export interface TrainingAreaNavProps {
	hasCompletedEvaluation?: boolean;
}

const TrainingAreaNav: React.FunctionComponent<TrainingAreaNavProps> = ({ hasCompletedEvaluation = true }) => {
	const items = [
		{ to: '/training/myPlan', text: 'My Plan', locked: !hasCompletedEvaluation },
		{ to: '/training/openGym', text: 'Open Gym' },
		{ to: '/training/gameDay', text: 'Game Day', locked: !hasCompletedEvaluation },
	];

	const sortedItems = [...items].sort((a, b) => {
		const aLocked = !!a.locked;
		const bLocked = !!b.locked;
		if (aLocked === bLocked) {
			return 0;
		}
		return aLocked ? 1 : -1;
	});

	return <AreaNav items={sortedItems} />;
};
export default TrainingAreaNav;
